import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthInterceptor } from "../../services/AuthInterceptor.Service";
import Spinnerr from "../Commaon/Spinner";
import Toaster from "../Commaon/Toaster";

const ViewPackage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [pkg, setPkg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState(null);

  useEffect(() => {
    const fetchPackage = async () => {
      try {
        setLoading(true);
        const res = await AuthInterceptor(`/admin/package/${id}`, {
          method: "GET",
        });

        if (res.data?.r) {
          setPkg(res.data.r);
        } else {
          throw new Error("Package not found");
        }
      } catch (error) {
        setSnack({
          notification: {
            message: "Failed to load package details",
            type: "error",
          },
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPackage();
  }, [id]);

  const Field = ({ label, value }) => (
    <div className="mb-3">
      <label className="form-label text-muted small">{label}</label>
      <div className="fw-semibold">{value || "-"}</div>
    </div>
  );

  return (
    <>
      {loading && <Spinnerr show />}
      {snack && (
        <Toaster
          notification={snack.notification}
          onClose={() => setSnack(null)}
        />
      )}

      <div className="card shadow-sm border-0 rounded-3 p-4">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="mb-0">Package Details</h2>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
        </div>

        {pkg && (
          <>
            {/* BASIC INFO */}
            <div className="row">
              <div className="col-md-6">
                <Field label="Title" value={pkg.title} />
              </div>
              <div className="col-md-6">
                <Field label="Age Limit" value={pkg.ageLimit} />
              </div>

              <div className="col-12">
                <Field label="Description" value={pkg.description} />
              </div>
            </div>

            <hr />

            {/* SAMPLE & REPORT */}
            <div className="row">
              <div className="col-md-6">
                <Field label="Sample Type" value={pkg.sampleType} />
              </div>
              <div className="col-md-6">
                <Field label="Report" value={pkg.report} />
              </div>

              <div className="col-md-6">
                <Field label="Fasting" value={pkg.fasting} />
              </div>
              <div className="col-md-6">
                <Field
                  label="Recommended Gender"
                  value={pkg.recommendedGender}
                />
              </div>
            </div>

            <hr />

            {/* PRICING */}
            <div className="row">
              <div className="col-md-3">
                <Field
                  label="MRP"
                  value={`₹ ${pkg.originalPrice}`}
                />
              </div>
              <div className="col-md-3">
                <Field
                  label="Discounted Price"
                  value={pkg.discountedPrice ? `₹ ${pkg.discountedPrice}` : "-"}
                />
              </div>
              <div className="col-md-3">
                <Field
                  label="Discount %"
                  value={pkg.discountPercent ? `${pkg.discountPercent}%` : "-"}
                />
              </div>
              <div className="col-md-3">
                <Field
                  label="GST Slab"
                  value={`GST ${pkg.gstSlab ?? pkg.gst ?? 0}%`}
                />
              </div>
            </div>

            <hr />

            {/* TEST DETAILS */}
            <div className="row">
              <div className="col-12">
                <Field label="Note" value={pkg.testCriteria} />
              </div>
              <div className="col-12">
                <Field label="Test Instruction" value={pkg.testInstruction} />
              </div>
            </div>

            <hr />

            {/* IDS */}
            <div className="row">
              <div className="col-md-6">
                <Field
                  label="Test IDs"
                  value={
                    Array.isArray(pkg.testIds)
                      ? pkg.testIds.join(", ")
                      : "-"
                  }
                />
              </div>
            </div>

            <hr />

            {/* STATUS */}
            <div className="row">
              <div className="col-md-6">
                <Field
                  label="Status"
                  value={pkg.isActive ? "Active" : "Inactive"}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ViewPackage;
